// biome-ignore lint/style/noRestrictedImports: encapsulation
import { drop as drop_ } from "remeda";

import { unpurry } from "./_unpurry";

export const drop = unpurry(drop_, 2);
